// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4bf55ec3] .el-tabs--card > .el-tabs__header .el-tabs__nav {\n  border-bottom: 1px solid #E4E7ED;\n}", ""]);
// Exports
module.exports = exports;
